import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'

import { Paths, Pages } from 'routing'

const App = () => (
  <BrowserRouter>
    <Switch>
      <Route path={ Paths.HOME } component={ Pages.HomePage } />
    </Switch>
  </BrowserRouter>
)

export default App;
